import { render, staticRenderFns } from "./RoomsDropdown.vue?vue&type=template&id=1f85fb1b&scoped=true&lang=pug&"
import script from "./RoomsDropdown.vue?vue&type=script&lang=js&"
export * from "./RoomsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RoomsDropdown.vue?vue&type=style&index=0&id=1f85fb1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85fb1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VProgressLinear,VSheet,VTextField})
